import Participantes from './Participantes';
export default Participantes;
